// libs
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import isEmpty from 'lodash/isEmpty';

//Selectors
import { getSSRHeaders } from 'shared/store/app/selectors';
import {
  isFetching as _isFetching,
  isFetchingError as _isFetchingError,
  isNotFound as _isNotFound,
  getLandingPageData,
  isI18n as _isI18n,
} from 'shared/store/landingpage/selectors';

// Redux Store
import { fetchHomepageData as _fetchHomepageData } from 'shared/store/landingpage/services';
import { getUserI18N } from 'shared/store/internationalization/selectors';
import { updateStatusCode as _updateStatusCode } from 'shared/store/app/actions';

// constants
import { DEFAULT_COUNTRY } from 'shared/layouts/Homepage/constants';

// def
import {
  IHomepageStateProps,
  IHomepageDispatchProps,
  IHomepageProps,
} from 'shared/layouts/Homepage/types';

// components
import HomepageAPI from './HomePageAPI';

const mapStateToProps = (state: any) => {
  return {
    isI18n: _isI18n(state),
    homepageData: getLandingPageData(state),
    ssrHeaders: getSSRHeaders(state),
    country: getUserI18N(state)['countryCode'],
    isFetchingError: _isFetchingError(state),
    isFetching: _isFetching(state),
    isNotFound: _isNotFound(state),
  };
};

const mapDispatchToProps = {
  fetchHomepageData: _fetchHomepageData,
  updateStatusCode: _updateStatusCode,
};

const fetchData = async ({
  homepageData,
  fetchHomepageData,
  ssrHeaders,
  pageName,
  country,
  updateStatusCode,
}: IHomepageProps) => {
  if (isEmpty(homepageData)) {
    const headers = __SERVER__ ? ssrHeaders : {};
    let isI18n = false;
    if (__SERVER__) {
      const onI18nNetwork =
        !isEmpty(headers['x-base-country-code']) &&
        headers['x-base-country-code'] !== DEFAULT_COUNTRY;

      const i18nShippingSelected =
        !isEmpty(headers['x-country-code']) && headers['x-country-code'] !== DEFAULT_COUNTRY;

      // either user has selected international shipping or
      // he is on international network but not selected any shipping.
      if ((onI18nNetwork && i18nShippingSelected) || i18nShippingSelected) {
        isI18n = true;
      }
    } else if (country !== DEFAULT_COUNTRY) {
      isI18n = true;
    }

    return fetchHomepageData(headers, pageName, isI18n).catch((err: { status: number }) => {
      if (err.status === 404) {
        updateStatusCode(404);
      } else {
        updateStatusCode(500);
      }
    });
  }
};

export default connect<IHomepageStateProps, IHomepageDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(frontloadConnect(fetchData)(HomepageAPI));
